export const FAQS = 'FAQS';
export const MAP = 'MAP';
export const DISCLAIMER = 'DISCLAIMER';
export const QUERIES = 'QUERIES';
